// @flow
import { darken } from 'polished';

import { Colors } from '@zapier/theme';

/**
 * If changing DEFAULT_SIGN_UP_URL, make sure to revisit
 * how redirection is handled when there is a next param in the URL.
 * Currently, users are first taken to app/onboarding and then
 * redirected to the path inside next param, which is the page that
 * they tried to access as a non-member.
 */
export const DEFAULT_LOGIN_URL = '/app/dashboard';
export const PLATFORM_LOGIN_URL = '/app/developer';
export const DEFAULT_SIGN_UP_URL = '/app/onboarding';

export const CAPTCHA_CLIENT_SITE_KEY =
  '6LdY6DkUAAAAADQgB2MNeHGblu1EzzSjGm437aPQ';
export const CAPTCHA_CLIENT_REF = 'recaptcha';
export const CAPTCHA_REQUIRED_FIELD_ERROR = 'captcha_required';
export const EVENT_CAPTCHA_RENDERED = 'signup: captcha rendered';
export const EVENT_CAPTCHA_VERIFICATION_FAIL =
  'signup: captcha verification failed';

export const EVENT_ONE_TAP_GOOGLE_IFRAME_LOAD_FAILED =
  'google yolo iframe failed to load';
export const EVENT_ONE_TAP_GOOGLE_IFRAME_CLOSED =
  'google yolo iframe closed by user';

export const SignupType = Object.freeze({
  oneTap: 'one-tap',
  googleOneTap: 'google-one-tap',
  sso: 'sso',
  googleSso: 'google-sso',
  direct: 'direct',
  facebookSso: 'facebook-sso',
  flab: 'flab-abs',
  flabSso: 'flab-sso',
});

export const defaultSSOButtonCSS = {
  alignItems: 'center',
  backgroundColor: Colors.white,
  border: `1px solid ${Colors.adamantium}`,
  borderRadius: '4px',
  boxShadow: '0 0 1px rgba(#000, 0.12), 0 1px 1px rgba(#000, 0.24)',
  color: '#4d4d4d',
  display: 'flex',
  fontSize: 13,
  padding: 10,
  position: 'relative',
  ':hover,:focus': {
    background: darken(0.03, Colors.white),
    textDecoration: 'none',
  },
};
